module.exports = __webpack_public_path__ + "static/img/obj8.3d74382d.png";